import { createIconUI } from '@ibsys/kit';
import { ComponentProps } from 'react';

import mappingIcons from './mapping';

export const Icon = createIconUI(mappingIcons);
export type IconProps = ComponentProps<typeof Icon>;
